__turbopack_context__.v({
  "audioPlayer": "audio-player-module-scss-module__ivHgkW__audioPlayer",
  "audioPlayerAudio": "audio-player-module-scss-module__ivHgkW__audioPlayerAudio",
  "audioPlayerButton": "audio-player-module-scss-module__ivHgkW__audioPlayerButton",
  "audioPlayerButtonIcon": "audio-player-module-scss-module__ivHgkW__audioPlayerButtonIcon",
  "audioPlayerTitle": "audio-player-module-scss-module__ivHgkW__audioPlayerTitle",
  "audioPlayerTrack": "audio-player-module-scss-module__ivHgkW__audioPlayerTrack",
  "isPlaying": "audio-player-module-scss-module__ivHgkW__isPlaying",
});
